import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import { formatDate } from 'helpers/dateHelper';
import parse from 'html-react-parser';
import { Hypothesis } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/GVT/PayConstants/helpers/types';
import { currencyFormatter } from 'helpers/formatHelper';
import Flex from 'ui/Flex/Flex';

type Props = {
    hypothesis: Hypothesis;
    hypothesisName: string;
};

const GVTHypothesis = ({
    hypothesis,
    hypothesisName,
}: Props): React.ReactElement => {
    const { t } = useTranslation();
    const { value, defaultValue, date } = hypothesis;
    const isGvtHypothesisUndefined =
        value === 0 && defaultValue === 0 && date === '';
    const isIndexRaiseHypothesis =
        hypothesisName ===
        t('humanResources.simulation.valuePointRaiseEvolution');

    const formattedDate =
        new Date(date) < new Date()
            ? `<span style="color: red;">${formatDate(new Date(date))}</span>`
            : formatDate(new Date(date));

    const oldFormattedValue = defaultValue
        ? `<strong>${currencyFormatter(defaultValue)}</strong>`
        : '';
    const newFormattedValue = isIndexRaiseHypothesis
        ? `${value}`
        : `${currencyFormatter(value)}`;
    const hypothesisDisplay = isIndexRaiseHypothesis
        ? 'gvtFreeHypothesis'
        : 'gvtHypothesis';
    const parsedContent = parse(
        t(
            `humanResources.simulation.duplicateSimulation.thirdStep.${hypothesisDisplay}`,
            {
                date: formattedDate,
                oldValue: oldFormattedValue,
                newValue: newFormattedValue,
            },
        ),
    );

    return (
        <>
            {!isGvtHypothesisUndefined && (
                <Flex
                    justifyContent="space-between"
                    sx={{ marginBottom: '1rem' }}
                >
                    <Typography
                        sx={{ alignText: 'center' }}
                        variant="body1SemiBold"
                    >
                        {hypothesisName}
                    </Typography>
                    <Typography sx={{ alignText: 'center' }} variant="body2">
                        {parsedContent}
                    </Typography>
                </Flex>
            )}
        </>
    );
};

export default GVTHypothesis;
